<div class="container kite-container">
    <div class="row">
        <div class="col-6">
            <button type="button" class="btn kite-btn-back" aria-label="Close"
                [routerLink]="['/dashboard' + regresar + '/' + tipoMenu]">
                <i class="fa fa-angle-left"></i>
                Go Back
            </button>
        </div>
        <div class="col-6">
            <h3 class="float-right mr-3">SERVICE AGREEMENT</h3>
            <br>
        </div>
    </div>
    <br>
    <!-- Form row -->
    <div class="row animated fadeIn mt-1">
        <div class="col-12">
            <div class="card">
                <div class="card-body border kite-vpborder bg-white">
                    <form [formGroup]="projectForm" (ngSubmit)="addProject()" autocomplete="off" ngNativeValidate>
                        <div class="row">
                            <div class="col-lg-5 col-md-12 mb-2" *ngIf="!selectHide">
                                <form [formGroup]="form">
                                    <kt-autocomplete-input class="w-100" formControlName="name_client_select"
                                        (itemSelected)="setItemSelected($event)" [moreValidations]="false"
                                        [formGroup]="form" [isValid]="!this.form.valid"
                                        [options]="inputs.name_client_select" [allData]="clients_arr">
                                    </kt-autocomplete-input>
                                </form>
                            </div>
                            <div class="col-lg-10 col-md-10 mb-2" *ngIf="selectHide">
                                <label for="inputEmail4" class="label">Prospect</label>
                                <input type="text" class="kite-form-control form-control" id="name_prospect"
                                    placeholder="" formControlName="name_client_address" toUppercase>
                            </div>
                            <div class="col-lg-2 col-md-2 mb-2">
                                <label for="inputEmail4" class="label">ID Customer</label>
                                <input type="text" class="kite-form-control-agreement form-control" id="ident_GUI"
                                    placeholder="" formControlName="ident_GUI" toUppercase disabled>
                            </div>
                            <div class="col-lg-2 col-md-4 mb-2">
                                <label for="price" class="label">Price</label>
                                <input min="0" class="form-control" currencyMask
                                    [options]="{ thousands: '.', precision: 2, prefix: '$', decimal: ',' }" id="price"
                                    placeholder="$" formControlName="price">
                                <small *ngIf="priceNoValido?.errors?.['required'] && priceNoValido?.['touched']"
                                    class="animated fadeIn text-danger">
                                    *Required
                                </small>
                            </div>
                            <div class="col-lg-4 col-md-8 mt-2 align-self-center">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" formControlName="per" id="per_gallons"
                                        value="per_gallons">
                                    <label class="label" for="per_gallons">PER GALLONS</label>
                                </div>
                                <div class="form-check form-check-inline p-0">
                                    <input class="form-check-input" type="radio" formControlName="per" id="per_pounds"
                                        value="per_pounds">
                                    <label class="label" for="per_pounds">PER POUNDS</label>
                                </div>
                                <small *ngIf="perNoValido"
                                    class="animated fadeIn text-danger d-flex justify-content-center">
                                    *Required
                                </small>
                            </div>
                            <div class="col-lg-2 col-md-4 mb-2">
                                <label for="porcentage" class="label">Per percentage</label>
                                <input type="text" class="form-control" id="porcentage" placeholder="%"
                                    formControlName="per_percentage">
                                <small
                                    *ngIf="porcentageNoValido?.errors?.['required'] && porcentageNoValido?.['touched']"
                                    class="animated fadeIn text-danger">
                                    *Required
                                </small>

                                <small *ngIf="porcentageNoValido?.errors?.['pattern']"
                                    class="animated fadeIn text-danger">
                                    *Data invalid
                                </small>
                            </div>
                            <div class="col-lg-2 col-md-4 mb-2">
                                <label for="gallons" class="label">Gallons per Week</label>
                                <input type="number" min="0" class="form-control" id="gallons" placeholder=""
                                    formControlName="gallons">
                            </div>
                            <div class="col-lg-2 col-md-4 mb-2">
                                <label for="container_size" class="label">Container(s)
                                    Size</label>
                                <input type="number" min="0" class="form-control" id="container_size" placeholder=""
                                    formControlName="container_size">
                            </div>
                            <div class="col-12 mb-2">
                                <label for="contact_name" class="label">Contact Name</label>
                                <input type="text" class="form-control" id="contact_name" placeholder=""
                                    formControlName="contact_name" toUppercase>
                            </div>
                            <div class="col-12 mb-2" *ngIf="msa_control">
                                <label for="floatingTextarea" class="label">Master Services
                                    Agreement</label>
                                <wj-auto-complete #msa class="form-control pb-0 pt-1" formControlName="master_agreement"
                                    [placeholder]="'SELECT MSA'" (initialized)="initAutoComplete(msaInput)" id="msa"
                                    [displayMemberPath]="'name'" [itemsSource]="msa_arr"></wj-auto-complete>
                            </div>

                            <!-- Payment information Card-->
                            <div class="card">
                                <div class="card-body sa-card">
                                    <div class="col mb-2">
                                        <div class="row">
                                            <div class="col-12 mb-2">
                                                <p class="sa-p"><strong>Note:</strong> "Please note that the following
                                                    information is included in the financial data of the project. The
                                                    sales team has full and sole responsibility
                                                    for the data presented below. Therefore, before processing the
                                                    service agreement, each salesperson must validate and verify the
                                                    financial information of the client"</p>
                                                <p class="sa-p"><strong>Nota:</strong> "Tenga en cuenta que la siguiente
                                                    información está incluida en los datos financieros del proyecto. El
                                                    equipo de ventas tiene la responsabilidad
                                                    total y exclusiva de los datos presentados a continuación. Por lo
                                                    tanto, antes de procesar el acuerdo de servicio, cada vendedor debe
                                                    validar y verificar la
                                                    información financiera del cliente"</p>
                                            </div>
                                            <div class="col-lg-4 col-md-4 mb-2">
                                                <label for="floatingTextarea" class="label">Payment
                                                    Method</label>
                                                <wj-auto-complete #payment class="form-control pb-0 pt-1"
                                                    formControlName="payment_method" id="payment_method"
                                                    [displayMemberPath]="'name'"
                                                    [itemsSource]="payment_methods"></wj-auto-complete>
                                            </div>
                                            <div class="col-lg-8 col-md-8 mb-2">
                                                <label for="contact_name" class="label">Pay to
                                                    Order of (if check is selected)</label>
                                                <input type="text" class="form-control" id="payment_to" placeholder=""
                                                    formControlName="payment_to" toUppercase>
                                            </div>
                                            <div class="col">
                                                <div class="form-check form-check-inline p-0">
                                                    <input class="form-check-input" type="checkbox" id="same_data"
                                                        (click)="sameData()">
                                                    <label class="label" for="same_data">Use Main
                                                        address information</label>
                                                </div>
                                            </div>
                                            <div class="col-12 mt-1">
                                                <label for="contact_name"
                                                    class="label">Address</label>
                                                <input [readonly]="mainAddress" type="text" class="form-control"
                                                    id="payment_to" placeholder="" formControlName="check_address"
                                                    toUppercase>
                                            </div>
                                            <div class="col-lg-3 col-md-6">
                                                <label for="contact_name"
                                                    class="label">Country</label>
                                                <input [readonly]="true" type="text" class="form-control"
                                                    id="payment_to" placeholder="" formControlName="check_country"
                                                    toUppercase>
                                            </div>
                                            <div class="col-lg-3 col-md-6">
                                                <label for="contact_name"
                                                    class="label">State</label>
                                                <wj-auto-complete [isReadOnly]="mainAddress" #state
                                                    class="form-control pb-0 pt-1" formControlName="check_state"
                                                    [placeholder]="'SELECT STATE'" id="state"
                                                    [displayMemberPath]="'name'"
                                                    [itemsSource]="states"></wj-auto-complete>
                                            </div>
                                            <div class="col-lg-3 col-md-6">
                                                <label for="contact_name"
                                                    class="label">City</label>
                                                <wj-auto-complete [isReadOnly]="mainAddress" #city
                                                    class="form-control pb-0 pt-1" formControlName="check_city"
                                                    [placeholder]="'SELECT CITY'" id="city" [displayMemberPath]="'name'"
                                                    [itemsSource]="cities"></wj-auto-complete>
                                            </div>
                                            <div class="col-lg-3 col-md-6">
                                                <label for="contact_name" class="label">Zip
                                                    Code</label>
                                                <input [readonly]="mainAddress" type="text" class="form-control"
                                                    id="payment_to" placeholder="" formControlName="check_zip"
                                                    toUppercase>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--End Card-->
                        </div>
                        <div class="row">
                            <div class="col-lg-12 mb-2">
                                <label for="floatingTextarea" class="label">Special Requirements /
                                    Directions
                                    ({{projectForm?.controls?.special_requirements?.value?.toString()?.length}} of 350
                                    characters)</label>
                                <textarea class="form-control" placeholder="" id="floatingTextarea"
                                    style="height: 100px;" formControlName="special_requirements"
                                    oninput="this.value = this.value.toLowerCase();" maxlength="350"></textarea>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <button type="button" class="btn kite-button-edit float-right"
                                    style="width: 100px; color: white;" (click)="editProjectData()"
                                    [hidden]="btnFormHide">
                                    EDIT
                                </button>
                                <button type="button" class="btn kite-button-cancel float-right mr-3"
                                    style="width: 100px; color: white;" (click)="editCancel()" [hidden]="btnFormHide">
                                    CANCEL
                                </button>
                                <button type="submit" class="btn btn-themecolor kite-button float-right"
                                    style="width: 100px;" [hidden]="!btnFormHide" [disabled]="!projectForm.valid">
                                    ADD
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
    <div class="row animated fadeIn mt-3" style="padding:3%!important;">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card p-0">
                <div class="card-body bg-white p-0">
                    <div class="row">
                        <div class="col-12">
                            <table class="kite-table mb-0">
                                <thead class="bg-light">
                                    <tr class="text-center">
                                        <th class="border border-secondary w150" colspan="2" scope="col-md-2">CLIENT
                                            NAME</th>
                                        <th class="border border-secondary " scope="col">PRICE / PERCENTAGE</th>
                                        <th class="border border-secondary " scope="col">requirements</th>
                                    </tr>
                                </thead>
                                <tbody class="border border-secondary"
                                    *ngFor="let item of projects_arr; let i = index;">
                                    <tr>
                                        <td class="border border-secondary text-center text-nowrap"
                                            style="max-width: 40px;">
                                            <button type="button" class="btn btn-link p-0" (click)="editProjectDataTable(item, i)"
                                                data-toggle="tooltip" data-original-title="Edit" title="Edit" aria-label="Edit">
                                                <i class="fa fa-edit text-inverse m-r-7" aria-hidden="true"></i>
                                            </button>
                                            <button type="button" class="btn btn-link p-0 pointer" data-toggle="tooltip" title="Remove project" aria-label="Remove project" (click)="removeProject(item)">
                                                <i class="fa fa-trash text-inverse" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                        <td class="border border-secondary">{{item.name_project | uppercase}}</td>
                                        <td class="border border-secondary text-center">{{item.price !== '' ? item.price
                                            : item.per_percentage }}</td>
                                        <td class="border border-secondary">{{item.special_requirements}}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                        <div class="row d-none">
                            <div class="col-12 md-5">
                                <div class="center-div" id="qr">
                                    <qrcode [elementType]="tipoElemento" [qrdata]="valor" [width]="250"
                                        [errorCorrectionLevel]="correctionLevel"></qrcode>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="row">
                <div class="col">
                    <div class="kite-comments">
                        <ul style="list-style: none;">
                            <li class="text-justify">» The equipment is owned by KITE ENVIROMENTAL Inc. and must be used
                                exclusively for used cooking oil.</li>
                            <li class="text-justify">» The customer agrees to maintain the exterior of the container(s)
                                in clean condition.</li>
                            <li class="text-justify">» In the event of the termination of the service agreement the
                                equipment shall be removed by KITE ENVIROMENTAL personnel.</li>
                            <li class="text-center"><a
                                    href="https://kite-pro.com/back/uploads/annex/ANNEX_SERVICE_AGREEMENT.pdf"
                                    target="_blank">View Annexes.</a></li>
                        </ul>
                    </div>

                    <div class="row mt-3 mb-2" *ngIf="!signControl">
                        <div class="col-12 text-center mb-2">
                            <h3 class="label">Sign Document</h3>
                        </div>

                        <div class="col text-right">
                            <button class="btn kite-button pr-3" (click)="zoho = false">
                                <i class="fas fa-pencil-alt"></i> Self Sign
                            </button>
                        </div>
                        <div class="col text-left border-left pr-3">
                            <button class="btn sign-button" (click)="zoho = true">
                                <i class="far fa-envelope"></i> Sign by Email
                            </button>
                        </div>
                    </div>

                    <div class="card-body border border-ligth rounded-3 my-2" *ngIf="zoho">
                        <div class="col text-left">
                            <ul>
                                <li> » You have chosen to use KITEPro's Electronic Signature service. This service will
                                    send a message to the customer's email "{{clientSelected.name_client}}" describing
                                    the steps to follow to sign the Service Agreement and its annexes. </li> <br>
                                <li> » Before sending the signature request, make sure that the customer has been
                                    informed of the process and has the availability to sign it within a <strong>
                                        maximum period of 48 hours </strong>, which is the maximum validity period of
                                    the document. For security purposes, if the document remains unsigned after the
                                    specified time, the system will automatically cancel it, and you will need to
                                    initiate a new signing process.
                                </li><br>
                                <li> » Finally, once the Service Agreement and the annex have been signed, you will
                                    receive an email from KITEPro informing you that the document has been processed by
                                    the customer and will be enabled in the system for the next processes.</li>.
                            </ul>
                        </div>
                    </div>

                    <div *ngIf="!signControl">
                        <div class="card-body border border-ligth rounded-3 my-2" *ngIf="!zoho">
                            <div class="col text-center">
                                <signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart()"
                                    (drawEnd)="drawComplete()"></signature-pad>
                                <br>
                                <button type="button" class="btn btn-primary kite-button mb-2 border-0"
                                    (click)="clearPad()">Reset</button>
                            </div>
                        </div>
                    </div>


                    <div class="card-body border kite-vpborder bg-white row"
                        *ngIf="ROLE == 'ADMIN_ROLE' || ROLE == 'SUPER_ADMIN_ROLE'">
                        <div class="col-6">
                            <label class="label" for="agreementSignatureFile">Validating Signature by Upload Support
                                File</label>
                            <div class="input-group">
                                <input id="agreementSignatureFile" #inputfile type="file" class="border border-1 rounded-start"
                                    [disabled]="isInputDisabled" placeholder=""
                                    (change)="setFile($event.target.files[0])">
                                <!--  <span class="input-group-text btn-success rounded-end pointer" (click)="showFiles()">
                            Upload
                        </span> -->
                            </div>
                        </div>
                        <div class="col-6 justify-content-end d-flex">
                            <div>
                                <label class="label" for="agreementAttachDocs">Attach documents</label>
                                <div class="input-group">
                                    <input id="agreementAttachDocs" #inputfileAnnex type="file" multiple accept=".png, .jpeg, .jpg, .pdf"
                                        class="border border-1 rounded-start" [disabled]="false" placeholder=""
                                        (change)="setFileAttach($event.target.files)">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div>
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                          <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Home</button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Profile</button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">Contact</button>
                        </li>
                      </ul>
                      <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">dfgd</div>
                        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">dgdfgd</div>
                        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">sdfgsdfgd</div>
                      </div>
                </div> -->
                    <button type="button" class="btn btn-themecolor mt-4 kite-button" (click)="saveDraft()">Save
                        Draft</button>
                    <!-- <button type="button" class="btn btn-themecolor mt-4 kite-button float-right" *ngIf="is_draft" [disabled]="isBtnDisabled" (click)="completeAgreement()">Complete Service Agreement</button> -->
                    <button type="button" class="btn btn-themecolor mt-4 kite-button float-right"
                        [disabled]="isBtnDisabled" (click)="newAgreement()">Create Service Agreement</button>
                </div>
            </div>
        </div>
    </div>


    <div class="fondo-modal-imagen animate fadeIn fast" [class.hide]="modal_control">
        <div class="modal fade show d-block" id="exampleModal" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalLabel1">
            <div class="modal-dialog" role="document" style="max-width: 635px;">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="exampleModalLabel1">SELECT AGREEMENT TYPE</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            (click)="closeModal()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row modal-contain">
                            <div class="col m-2 p-2 box" (click)="selectType('msa')">
                                <img class="kite-icon" src="../../../../../../assets/master.svg">
                                <h5>
                                    Master
                                </h5>
                            </div>
                            <div class="col m-2 p-2 box" (click)="selectType('single')">
                                <!-- <img src="../../../../../../dev/assets/single.svg"> -->
                                <img class="kite-icon" src="../../../../../../assets/single.svg">
                                <h5>
                                    Single
                                </h5>
                            </div>
                            <div class="col m-2 p-2 box" (click)="selectType('adendum')">
                                <img class="kite-icon" src="../../../../../../assets/adendum.svg">
                                <h5>
                                    Adendum
                                </h5>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
        </div>
    </div>










</div>